const isSetButFalsy = (value) => {
  return typeof value !== 'undefined' && !value;
};

export { isSetButFalsy };
